import { z } from 'zod';

export const ContentfulDocumentSchema = z.looseObject({
  nodeType: z.string(),
  data: z.record(z.string(), z.any()),
  content: z.array(z.any())
});
